export const toTitleCase = str => {
  return str.replace(
    /\w\S*/g,
    txt => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    }
  )
}

export const stripHtml = str => {
  if (typeof document !== "undefined") {
    var tmp = document.createElement("DIV")
    tmp.innerHTML = str
    return tmp.textContent || tmp.innerText || ""
  }
  return str
}

export const convertMmToInches = mm => {
  const inches = Number(mm) * 0.0393700787
  return Math.max(Math.round(inches * 10) / 10).toFixed(1)
}

export const cookie = {

  get: (key) => {
    const result = (new RegExp("(?:^|; )" + encodeURIComponent(key) + "=([^;]*)")).exec(document.cookie)
    return (result && result[1] && result[1] !== "null") ? decodeURIComponent(result[1]) : null
  },

  set: (key, value, days) => {
    let expires = "";
    if (days) {
      const date = new Date()
      date.setDate(date.getDate() + days)
      expires = "; expires=" + date.toUTCString()
    }
    return document.cookie = key + "=" + (value || "")  + expires + "; path=/"
  }
}

export const trackEvent = (category, action, label, value) => {
  if (window.hasOwnProperty("ga"))
    window.ga("send", "event", category, action, label, value)
}
